import { usePagination } from "./use-paginations";
import { SearchFilesParamsEntryType, SearchMode, useSearchQuery } from "@/api/files";

interface DriveSearchParams {
  folderId?: string | undefined;
  query: string;
  entry_type?: SearchFilesParamsEntryType[];
  only_shared?: boolean;
  search_mode?: SearchMode;
}

export const useDriveSearch = ({ folderId, query, entry_type, only_shared, search_mode }: DriveSearchParams) => {
  const {
    isLoading,
    isFetching,
    data: displayItems,
    error,
    refetch,
  } = useSearchQuery({ fse_id: folderId, query, entry_type, only_shared, search_mode });

  const pagination = usePagination(displayItems || []);

  return {
    isLoading,
    error,
    isFetching,
    refetch,
    ...pagination,
    data: displayItems,
  };
};
